/**
 * Action Types
 */

export const Types = {
    SELECT_PEDIDO: 'pedido/SELECT_PEDIDO',
    DESELECT_PEDIDO: 'pedido/DESELECT_PEDIDO'
};

/**
 * Reducer
 */

const INITIAL_STATE = {};

export default function pedidoSelecionado(state = INITIAL_STATE, action) {
    switch (action.type) {
        case Types.SELECT_PEDIDO:
            return { ...state, ...action.payload };

        case Types.DESELECT_PEDIDO:
            return { ...INITIAL_STATE };

        default:
            return state;
    }
}

/**
 * Action Creators
 */

export const Creators = {
    selectPedido: (payload) => ({
        type: Types.SELECT_PEDIDO,
        payload
    }),
    deselectPedido: () => ({
        type: Types.DESELECT_PEDIDO
    })
};
